import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { T } from 'containers';

import { AppText } from 'domain/appText';
import { Spinner } from 'shared-components';

const ServerSaveStatusDiv = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    background: #FFFFFF;
    overflow: hidden;
    transition: all 0.5s;
    height: 45px;
    padding: 0px 10px;
    border-radius: 0px 12px 12px 0px;
    overflow: hidden;
`;

const SaveText = styled.span`
    display: flex;
    margin: 0px 5px;
    color: ${props => props.textColor};
    font-size: 13px;
    font-family: sans-serif;
`;

const SaveTimeText = styled.span`
    display: flex;
    margin: 0px 5px;
    color: ${props => props.textColor};
    font-size: 13px;
    font-family: sans-serif;
`;

const SaveStatusIcon = styled.img`
    width: 24px;
    height: 24px;
    margin-right: 15px;
    margin-left: 10px;

`;

const renderServerSaveStatus = (serverSaveStatus, saved, saveFailed, savePending) => {
  const { status, saveTime } = serverSaveStatus;
  if (!status || !saveTime) {
    return null;
  }
  let text = '';
  let textColor = '#2dcb70';
  let serverSaveStatusIconSrc = 'error';
  if (status === 'SUCCESS') {
    text = saved;
    serverSaveStatusIconSrc = 'ok';
  }
  if (status === 'PENDING') {
    text = savePending;
  }
  if (status === 'FAILED') {
    text = saveFailed;
    textColor = '#e40623';
  }
  return (
    <ServerSaveStatusDiv>
      {status === 'PENDING' && <Spinner className="save-status-spinner" size={1} />}
      {status !== 'PENDING' && <SaveStatusIcon src={`/assets/images/${serverSaveStatusIconSrc}.svg`} alt="Error" /> }
      <SaveText textColor={textColor}>{text}</SaveText>
      <SaveTimeText textColor={textColor}>{saveTime}</SaveTimeText>
    </ServerSaveStatusDiv>
  );
};

const ServerSaveStatus = ({
  serverSaveStatus,
}) => (
  <T
    text={[
      AppText.Saved,
      AppText.SaveFailed,
      AppText.SavePending,
    ]}
    render={([
      saved,
      saveFailed,
      savePending,
    ]) => (
        renderServerSaveStatus(serverSaveStatus, saved, saveFailed, savePending)
  )}
  />
);

ServerSaveStatus.propTypes = {
  serverSaveStatus: PropTypes.object,
};

export default ServerSaveStatus;



// WEBPACK FOOTER //
// ./src/components/organisms/ServerSaveStatus/index.js